import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { useLenis } from "@/hooks/useLenis";
import { Nav } from "@/components/landing/Nav";
import { Hero } from "@/components/landing/Hero";
import { Marquee } from "@/components/landing/Marquee";
import { Features } from "@/components/landing/Features";
import { Modes } from "@/components/landing/Modes";
import { Architecture } from "@/components/landing/Architecture";
import { Roadmap } from "@/components/landing/Roadmap";
import { Pricing } from "@/components/landing/Pricing";
import { Footer } from "@/components/landing/Footer";
import { DemoSimulator } from "@/components/landing/DemoSimulator";
import AdminPage from "@/pages/AdminPage";
import AuthPage from "@/pages/AuthPage";
import Terminal from "@/pages/Terminal";
import LandingSimple from "@/pages/LandingSimple";

const LandingPage = () => {
  useLenis();
  return (
    <div className="relative min-h-screen bg-ink text-white" data-testid="landing-page">
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Features />
        <Modes />
        <DemoSimulator />
        <Architecture />
        <Roadmap />
        <Pricing />
      </main>
      <Footer />
      <Toaster theme="dark" position="bottom-right" />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingSimple />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/masuk" element={<AuthPage />} />
          <Route path="/platform" element={<Terminal />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
